// removed by extract-text-webpack-plugin
module.exports = {"aboutContents":"aboutContents__1MNbE","achievementsWrapper":"achievementsWrapper__36Gfu","tileContainer":"tileContainer__3pDPb","imageContainer":"imageContainer__-oGD0","image":"image__MwvNP","arrowSize":"arrowSize__3lrhE","merchantSliderContainer":"merchantSliderContainer___NSiY","customPagination":"customPagination__1jAhv","pagination":"pagination__2TP7n"};


//////////////////
// WEBPACK FOOTER
// ./routes/campaign-activation/componentsVB/merchantsCarousel/style.css
// module id = BTul
// module chunks = 459